import API from "../../api/api";
import moment from "moment";

const $API = new API();

const TableDocs = {
  state: () => ({
    docsEvents: [],
    docsTypes: {
      pathology: ["pathological-report"],
      genetics: ["pgd-lab-results", "dnachip-lab-results", "exome-lab-results"]
    }
  }),
  getters: {
    docsTypes(state) {
      return state.docsTypes;
    },
    defaultDates() {
      return {
        startDate: moment(new Date())
          .subtract(3, "week")
          .format("YYYY-MM-DDT00:00:00"),
        endDate: moment().format("YYYY-MM-DDT00:00:00")
      };
    },
    eventsByType(state) {
      const events = {};
      if (!state.docsEvents?.length) return events;

      for (const key in state.docsTypes) {
        events[key] = state.docsEvents.filter(
          e =>
            e.file &&
            state.docsTypes[key].some(
              type => e.file.path.includes(type) || e.file.type.includes(type)
            )
        );
      }
      return events;
    },
    hasUnwatchedDocs: (state, getters) => (type = "pathology") => {
      if (!getters.eventsByType[type]) return false;
      return getters.eventsByType[type].some(e => e.count == 0);
    }
  },
  mutations: {
    SET_DOCS_LIST(state, events) {
      state.docsEvents = events.map(e => {
        const id = e.file && e.file.path ? e.file.path : "";
        const count = e.doctor_view_count
          ? e.doctor_view_count.doctor_view_count
          : 0;
        const is_available_online =
          e?.document_status?.document_status === "פעיל וזמין למטופל"
            ? "זמין"
            : "לא זמין";
        let located_report = "לא אותר";
        // If pathology type
        if (
          e.file &&
          state.docsTypes.pathology.some(
            type => e.file.path.includes(type) || e.file.type.includes(type)
          )
        ) {
          const foundReport = events.find(ev => {
            return (
              ev.real_patient?.real_patient_id ===
                e.real_patient?.real_patient_id &&
              (ev.file.description === "סיכום תוצאות פתולוגיה" ||
                ev.file.path.includes("-70."))
            );
          });
          if (foundReport) {
            const count = foundReport.view_count?.view_count;
            located_report = count && parseInt(count) > 0 ? "צפה" : "לא צפה";
          }
        }
        return { ...e, id, count, located_report, is_available_online };
      });
    },
    UPDATE_FILE_WATCHED(state, filePath) {
      const path = filePath.replace(
        "https://md-booking.hmc.co.il/ex-doctor/external",
        ""
      );
      const i = state.docsEvents.findIndex(e => e.id == path);
      if (i === -1) return;
      state.docsEvents[i].count++;
    }
  },
  actions: {
    async GET_DOCS_LIST({ commit, getters, rootGetters }, newDates) {
      const doctorId = rootGetters.activeDoctor.id;
      const dates = newDates ?? getters.defaultDates;

      if (!doctorId) return [];
      const res = await $API.getTableDocsList({
        doctorId,
        fromDate: moment(dates.startDate, "YYYY-MM-DDThh:mm:ss").format(
          "YYYY-MM-DD"
        ),
        toDate: moment(dates.endDate, "YYYY-MM-DDThh:mm:ss").format(
          "YYYY-MM-DD"
        )
      });
      if (!res || !res.data || !res.data.data) return [];

      commit("SET_DOCS_LIST", res.data.data);
      return res.data.data;
    }
  }
};

export default TableDocs;
